import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <>

    
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-text">
          <h1>FIND THE BEST FASHION<br />STYLE FOR YOU</h1>
          <p>
            Authentic Chikankari. Handcrafted With Love. From Classic Whites To Colorful Florals, Our Collection Celebrates The Grace Of Hand Embroidery And Indian Tradition. Shop Pure Craftsmanship Today
          </p>
         <div className="button-wrapper">
          <Link to="/collection" className="shop-btn" >EXPLORE MORE</Link>
        {/* <Link to="/collection" className="shop-btn" onClick={() => console.log('Shop Now clicked!')}>EXPLORE MORE</Link> */}
      </div>


        </div>

        <div className="hero-pattern">
          <img src="/images/lux Pattern.png" alt="pattern" />
        </div>
        <div className="hero-bottom-image">
    <img src="/images/Vector.png" alt="bottom background" />
  </div>
      </section>


      {/* Section1 */}
     <section className="fashion">
    <img src="/images/Frame 48098525.png" alt="Models" className="models-img" />
</section>

{/* Section2 */}

<section className="fashion2">

  <div className="fashion2-left">

    <img src="/images/Frame 48098526 copy.png" alt="New Pink" className="fashion2-img" />
    <h2> Pink Chikankari Fabric Material</h2>
  </div>

  <div className="fashion2-right">
    <img src="/images/vector1.png" alt="New Pink" className="fashion2-img1" />
    <h2 className="fashion2-title">Shop The Collection</h2>
    <div className="fashion2-cards">
      <div className="fashion2-card">
        <img src="/images/Rectangle 1.png" alt="Beige" />
        <p>Beige Chikankari Fabric Material</p>
      </div>
      <div className="fashion2-card">
        <img src="/images/Rectangle 2.png" alt="Red Saree" />
        <p>Red Chikankari Saree</p>
      </div>
      <div className="fashion2-card">
        <img src="/images/Rectangle 3.png" alt="Pink" />
        <p>Pink Chikankari Fabric Material</p>
      </div>
    <Link to="/collection" className="arrow-btn">→</Link>
          </div>
<div className="exclusive-card">
  <img src="/images/Rectangle 4499.png" alt="Slide 1" className="slide-img img1" />
  <img src="/images/Rectangle 4498 (1).png" alt="Slide 2" className="slide-img img2" />

  <div className="overlay">
    <h4>Aman Chikan Handicraft</h4>
    <h3>EXCLUSIVE</h3>
     <img src="/images/Frame 48098552.png" alt="Only Available Badge" className="badge-img" />
  </div>
</div>
  <img src="/images/vector1.png" alt="New Pink" className="fashion2-img1" />
  </div>
</section>


{/* Section3 */}
<section className="fashion3">
  <div className="fashion3-header">
    <h2>Drape the Essence of <br /> Royalty</h2>
    <p>Crafting Outfits That Leave a <br />Timeless Impression</p>
  </div>

  <div className="fashion3-grid">

    <div className="fashion3-card">
      <img src="/images/Rectangle 4499.png" alt="Ready Outfits"/>
      <h3>Kurti Sets</h3>
      <p>Handcrafted elegance in every thread. Featuring straight, A-line, and flared styles, paired with palazzo or pants — perfect for everyday grace or festive charm. Each piece tells a story of traditional artistry meeting contemporary sophistication.</p>
    </div>


    <div className="fashion3-card">
      <img src="/images/picture2.png" alt="Customization"/>
      <h3>Customization</h3>
      <p>Your style, your way. From size adjustments to color choices and personalized designs — we tailor every Chikankari piece to fit you perfectly. Experience the luxury of bespoke fashion where every stitch reflects your unique personality and preferences.</p>
    </div>

    <div className="fashion3-card">
      <img src="/images/picture3.png" alt="Fabric Material"/>
      <h3>Fabric Material</h3>
      <p>A wide range of breathable and elegant fabrics — cotton, georgette, mulmul, chiffon, and more — each handpicked to complement Chikankari embroidery beautifully. Premium materials that ensure comfort, durability, and timeless appeal in every garment.</p>
    </div>

    <div className="fashion3-card">
      <img src="/images/picture.png" alt="Semi Stitched"/>
      <h3>Semi Stitched</h3>
      <p>Perfectly flexible and easy to customize. Our semi-stitched Chikankari pieces gives you freedom to tailor the fit while enjoying the charm of authentic hand embroidery .</p>
    </div>
  </div>
</section>
      </>
  );
}

export default Home;



    
